export default "__VITE_ASSET__B6c7WNos__"